import * as ACTIONS from '../constants/pharmaEnrollForm';
import * as service from '../utils/service';
import { applyModel, hasNonEmptyValues, mapRadioNamesToIds, removeEmptyFields } from '../utils/utils';
import { enrollModel } from '../utils/models';

export const changeStep = step => dispatch => dispatch({
  type: ACTIONS.PHARMA_ENROLL.CHANGE_STEP,
  payload: {
    step,
  },
});

export const updatePatientInfo = (payload) => dispatch => dispatch({
  type: ACTIONS.PHARMA_ENROLL.UPDATE_PATIENT_INFO,
  payload: {
    ...payload,
  },
});

export const clearEnrollForm = () => dispatch => dispatch({
  type: ACTIONS.PHARMA_ENROLL.CLEAR,
});

export const submitFormInit = () => dispatch => dispatch({
  type: ACTIONS.SUBMIT_PHARMA_ENROLL_FORM.INIT,
  payload: {
    loading: true,
  },
});

export const submitFormError = error => dispatch => dispatch({
  type: ACTIONS.SUBMIT_PHARMA_ENROLL_FORM.ERROR,
  payload: {
    error,
    loading: false,
  },
});

export const submitFormSuccess = success => dispatch => dispatch({
  type: ACTIONS.SUBMIT_PHARMA_ENROLL_FORM.SUCCESS,
  payload: {
    success,
    loading: false,
  },
});

export const submitForm = () => (dispatch, getState) => {
  dispatch(submitFormInit());
  const { drugId, drugSelected, enrollmentSource, drugPatient, coverageType, planType, source, type } = getState().environment;
  const { patientInformation } = getState().pharmaEnrollForm;

  let payload = patientInformation;

  const updatedDrugAnswers = payload.drugAnswers = {
    ...payload.drugAnswers,
    hasPermissionOptIn: payload.hasPermissionOptIn,
    hasMarketingOptIn: payload.hasMarketingOptIn,
  };

  const formattedDrugAnswers = mapRadioNamesToIds(updatedDrugAnswers, drugSelected);

  payload = {
    ...payload,
    enrollmentSource: enrollmentSource,
    drugPatient: drugPatient,
    enrollmentDataSource: 'PHARMACIST',
    pharmacyInsurance: {
      ...payload.pharmacyInsurance,
      coverageType: coverageType,
      planType: planType,
      source: source,
    },
    drugAnswers: formattedDrugAnswers,
  };

  // add prescriber if it has values
  if (hasNonEmptyValues(payload.prescriber)) {
    payload.prescriber = {
      ...payload.prescriber,
      type: type,
    };
  } else {
    delete payload.prescriber;
  }

  payload = applyModel({ payload, model: enrollModel });
  payload = removeEmptyFields(payload);
  service.post({
    endpoint: `/${drugId}/enrollment`,
    payload,
  })
    .then((data) => dispatch(submitFormSuccess(data)))
    .catch(error => dispatch(submitFormError(error)));
};
